import { isNilOrEmpty } from '@shared/helpers/utils.helper';
import { MyVerbale } from '../../../../models/interfaces/revisione.interface';

/**
 * The API/XML template for a new verbale ships one empty row in ElContrattiUsati /
 * ElContrattiUsatiSociLavoratori (InfoPath removed it on XDocument_OnLoad, the FE never did),
 * making the required description control invalid right at opening. Drop rows left fully empty.
 */
export const normalizeContrattiUsatiArrays = (v: MyVerbale): MyVerbale => {
    const effBaseSociale = v?.my_SezioneI__Rilevazione?.my_EffettivitaBaseSociale;
    if (!effBaseSociale) return v;

    const elContrattiUsati = effBaseSociale.my_ContrattiUsati?.my_ElContrattiUsati;
    if (Array.isArray(elContrattiUsati)) {
        effBaseSociale.my_ContrattiUsati.my_ElContrattiUsati = elContrattiUsati.filter(
            (item) => !isNilOrEmpty(item?.my_ContrattiUsatiDescNome) || !isNilOrEmpty(item?.my_ContrUsatiDesc)
        );
    }

    const elContrattiUsatiSociLavoratori = effBaseSociale.my_ContrattiUsatiSociLavoratori?.my_ElContrattiUsatiSociLavoratori;
    if (Array.isArray(elContrattiUsatiSociLavoratori)) {
        effBaseSociale.my_ContrattiUsatiSociLavoratori.my_ElContrattiUsatiSociLavoratori = elContrattiUsatiSociLavoratori.filter(
            (item) => !isNilOrEmpty(item?.my_ContrattiUsatiSociLavoratoriDescNome) || !isNilOrEmpty(item?.my_ContrattiUsatiSociLavoratoriDesc)
        );
    }

    return v;
};
